import dayjs from 'dayjs';
import type { MonthGroupData, TimelineStudy } from '../types/studyTimeline';

export function groupByMonth(studies: TimelineStudy[]): MonthGroupData[] {
  const sorted = [...studies].sort(
    (a, b) => dayjs(b.updatedAt).valueOf() - dayjs(a.updatedAt).valueOf()
  );

  const groups = new Map<string, TimelineStudy[]>();

  sorted.forEach((study) => {
    const d = dayjs(study.studyDateTime);
    const key = d.format('YYYY-MM');
    const existing = groups.get(key);
    if (existing) {
      existing.push(study);
    } else {
      groups.set(key, [study]);
    }
  });

  return Array.from(groups.entries()).map(([key, monthStudies]) => ({
    key,
    label: dayjs(key, 'YYYY-MM').format('MMM YYYY').toUpperCase(),
    studies: monthStudies,
  }));
}
